import { createFileRoute } from "@tanstack/react-router";
import { m } from "#/paraglide/messages";
import {
  useGetScanUploads,
  useGetScanUploadProgress,
} from "#/lib/api/scan-upload";
import { PaginatedSearchSchema } from "#/lib/schemas/paginated-search";
import { ScanUploadsPage } from "#/components/pages/scan-uploads/scan-uploads-page";
import { useTenant } from "#/contexts/TenantContext";
import { useLegacyBackendUrl } from "#/hooks/use-legacy-url";
import { hasPermission, RESOURCE_PERMISSIONS } from "#/utils/permissions";

export const Route = createFileRoute("/$tenantCode/$market/scan-uploads")({
  beforeLoad: () => ({ getTitle: () => m["resources.scanUpload.name"]() }),
  validateSearch: PaginatedSearchSchema,
  component: ScanUploadsRoute,
});

function ScanUploadsRoute() {
  const { page, perPage } = Route.useSearch();
  const { permissions, isAdmin } = useTenant();
  const legacyBackendUrl = useLegacyBackendUrl();

  const { data, isLoading } = useGetScanUploads({
    page,
    perPage,
    dateUpload: new Date().toISOString().split("T")[0],
  });
  const { progressData } = useGetScanUploadProgress();

  const canViewProgress = hasPermission(
    permissions,
    isAdmin,
    RESOURCE_PERMISSIONS["scan-upload-progress"],
  );

  const backendFilesUrl =
    legacyBackendUrl !== "" ? `${legacyBackendUrl}/tmp` : "";

  const uploads = data?.member ?? [];
  const totalItems = data?.totalItems ?? 0;
  const pageCount = Math.ceil(totalItems / perPage);

  return (
    <ScanUploadsPage
      uploads={uploads}
      pageCount={pageCount}
      progressData={progressData}
      canViewProgress={canViewProgress}
      isLoading={isLoading}
      backendFilesUrl={backendFilesUrl !== "" ? backendFilesUrl : undefined}
    />
  );
}
